import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';

import { RemoteHttpService } from '../../remote-http';
import * as global from '../../globals';
import { ContentType, RemoteRequest } from '../../remote-request';
import { ClubInfo, ClubList, CourseHoleInfo, CourseInfo } from '../../data/club-course';
import { JsonService } from '../../json-util';
import { Observable, throwError } from 'rxjs';
import { isPresent } from '../common-service';
import { SearchCriteria } from '../../data/search-criteria';
import { Custom_RequestMethod } from '../common-service';
/*
 Generated class for the ClubService provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class ClubService {
  private searchCriteria: SearchCriteria;

  constructor(
    public http: RemoteHttpService,
    private requestMethod: Custom_RequestMethod
  ) {}

  /**
   * Gets the information about a single club
   * @param clubId The ID of the club
   */
  public getClubInfo(clubId: number): Observable<ClubInfo> {
    let request = new RemoteRequest(
      global.ServerUrls.getClub,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: clubId,
        fullDetails: true,
      }
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubInfo: ClubInfo = resp;
        // if (!isPresent(clubInfo.clubImage)) clubInfo.clubImage = "document/image/default_club.png";
        if (!isPresent(clubInfo.clubImage)) clubInfo.clubImage = './assets/image/default_club.png';

        JsonService.deriveFullUrl(clubInfo, 'clubImage');
        return clubInfo;
      })
    );
    // .pipe(catchError(this.http.handleError));
  }

  /**
   * Get the courses for a given club
   * @param clubId The ID of the club
   * @returns {Observable<R>}
   */
  public getClubCourses(clubId: number): Observable<Array<CourseInfo>> {
    let request = new RemoteRequest(
      global.ServerUrls.getClubCourses,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        clubId: clubId,
      }
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let courses: Array<CourseInfo> = resp;
        // JSON.parse(resp._body);
        courses.forEach((c: CourseInfo) => {
          JsonService.deriveFullUrl(c, 'photoUrl');
          c.holes.forEach((h: CourseHoleInfo) => {
            JsonService.deriveFullUrl(h, 'holeImage');
          });
        });
        return courses;
      })
    );
    // .pipe(catchError(this.http.handleError));
  }

  /**
   * Gets the nearby club within a certain distance
   * @param maxDistance The maximum distance from the club to current location.
   * The current location details are automatically addedd
   * @returns {Observable<R>} Returns the Observable with next method returning
   * array of ClubInfo objects
   */
  public getNearbyClubs(maxDistance: number = 10): Observable<Array<ClubInfo>> {
    //
    let request = new RemoteRequest(
      global.ServerUrls.getClubsNearby,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        maxDistance: maxDistance,
      }
    );

    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubInfos: Array<ClubInfo> = resp;
        clubInfos.forEach((c: ClubInfo) => {
          // if (!isPresent(c.clubImage)) c.clubImage = "document/image/default_club.png";
          if (!isPresent(c.clubImage)) c.clubImage = './assets/image/default_club.png';

          JsonService.deriveFullUrl(c, 'clubImage');
        });

        return clubInfos;
      })
    );
    // .pipe(catchError(this.http.handleError));
  }

  /**
   * Gets the recent clubs played. The ID of the player is automatically inserted
   * @param maxClubs The maximum number of recent clubs to return
   * @returns {Observable<R>}
   */
  public getRecentClubs(maxClubs: number = 10, type?: string): Observable<Array<ClubInfo>> {
    //
    let request = new RemoteRequest(
      global.ServerUrls.getRecentClubs,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        maxItems: maxClubs,
        type: type,
      }
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubInfos: Array<ClubInfo> = resp;
        clubInfos.forEach((c: ClubInfo) => {
          // if (!isPresent(c.clubImage)) c.clubImage = "document/";
          // if (!isPresent(c.clubImage)) c.clubImage = "./assets/image/default_club.png";

          JsonService.deriveFullUrl(c, 'clubImage');
          JsonService.deriveFullUrl(c, 'clubLogo');
          JsonService.deriveFullUrl(c, 'clubThumbnail');
        });

        return clubInfos;
      })
    );
    // .pipe(catchError(this.http.handleError));
  }

  /**
   * Search clubs
   * @param searchText The search text filter. The search is applied on clubName, tag, address,
   * city, state
   * @param activeOnly Only clubs with status "Active" are considered.
   * @param pageNumber The search happens in paged manner. This parameter specifies which page is
   * requested
   * @param countryId The optional country id. Only clubs from this country are returned. Clubs
   * without country are ignored
   * @returns {Observable<R>}
   */
  public searchClubs(
    searchText: string,
    activeOnly: boolean,
    pageNumber: number,
    countryId?: string
  ): Observable<ClubList> {
    let request = new RemoteRequest(
      global.ServerUrls.searchClubs,
      this.requestMethod.get,
      ContentType.URL_ENCODED_FORM_DATA,
      {
        searchText: searchText,
        activeOnly: activeOnly,
        pageNumber: pageNumber,
        countryId: countryId,
      }
    );
    return this.http.execute(request).pipe(
      map((resp: any) => {
        let clubList: ClubList = resp;
        if (clubList && clubList.clubs)
          clubList.clubs.forEach((c: ClubInfo) => {
            // if (!isPresent(c.clubImage)) c.clubImage = "document/";
            if (!isPresent(c.clubImage)) c.clubImage = './assets/image/default_club.png';

            JsonService.deriveFullUrl(c, 'clubImage');
          });
        return clubList;
      })
    );
    // .pipe(catchError(this.http.handleError));
  }

  // public setSearch(search: SearchCriteria) {
  //     this.searchCriteria = search;
  //     if (this.searchCriteria != null && !this.searchCriteria.maxDistance)
  //         this.searchCriteria.maxDistance = 10;
  //     //Save it
  //     this.pref.setPref("CompetitionFilter", search);
  // }

  // public getSearchCriteria () {

  // }

  // public setSearchCriteria() {

  // }
}
